import PropTypes from 'prop-types';
import Carousel from '@skeletons/Carousel/Carousel';
import CourseCard from './CourseCard';

const CourseCarousel = ({ number }) => (
  <Carousel number={number}>
    {new Array(number).fill(0).map((val) => (
      <CourseCard key={val} />
    ))}
  </Carousel>
);

CourseCarousel.propTypes = {
  number: PropTypes.number
};

CourseCarousel.defaultProps = {
  number: 3
};

export default CourseCarousel;
